import type { NavigatorStatus } from './types'

export const LABELS = {
  feature: 'Results Ownership Chart',
  features: 'Results Ownership Charts',
  seat: 'Role',
  seats: 'Roles',
  responsibility: 'Obsession',
  responsibilities: 'Obsessions',
  assignee: 'Owner',
  assignees: 'Owners',
  ownersBox: "Owner's Box",
} as const

export const NAVIGATOR_LABELS = {
  toggle: 'Navigator users',
  toggleHint: 'Show which owners have an active Navigator account',
  legendYes: 'Navigator user',
  legendNo: 'Not a Navigator user',
  badgeYes: 'Navigator',
  badgeNo: 'No Navigator',
} as const

// "a role" vs "an obsession" — keeps copy grammatical when a label changes.
export const indefiniteArticle = (word: string) => (/^[aeiou]/i.test(word) ? 'an' : 'a')

// The server rejects a filled role with nobody on it with this exact wording;
// the role editor blocks the selection with the same sentence so the two
// surfaces never disagree.
export const FILLED_REQUIRES_OWNER = 'An owner is required to mark this role as filled'

export const STATUS_LABELS: Record<string, string> = {
  filled: 'Filled',
  open: 'Open',
  needs_hire: 'Needs Hire',
  needs_resources: 'Needs Resources',
  placeholder: 'Placeholder',
}

export const STATUS_COLORS: Record<string, { bg: string; text: string; dot: string }> = {
  filled:          { bg: 'bg-sea/15',          text: 'text-sea',          dot: 'bg-sea' },
  open:            { bg: 'bg-stone',           text: 'text-text-primary',     dot: 'bg-charcoal/40' },
  needs_hire:      { bg: 'bg-marigold/15',     text: 'text-marigold',     dot: 'bg-marigold' },
  needs_resources: { bg: 'bg-pinnacle-red/10', text: 'text-pinnacle-red', dot: 'bg-pinnacle-red' },
  placeholder:     { bg: 'bg-terrain/15',      text: 'text-terrain',      dot: 'bg-terrain' },
}

export const NAVIGATOR_STATUS_LABELS: Record<NavigatorStatus, string> = {
  active: 'Navigator user',
  inactive: 'Not a Navigator user — their Navigator account is deactivated or pending',
  external: 'Not a Navigator user — added as an outside name',
}

export function navigatorSummary(navigatorUsers: number, totalPeople: number): string {
  const people = totalPeople === 1 ? 'person is a Navigator user' : 'people are Navigator users'
  return `${navigatorUsers} of ${totalPeople} ${people}`
}
